import { listStoreLenses } from 'root/src/client/logic/list/lenses'

const { viewHasMore } = listStoreLenses

export default (state, { moduleId }) => viewHasMore(moduleId, state)
